import { Component, Input } from '@angular/core';

import { IconMap } from '@app/core/providers/icon-provider';

@Component({
  selector: 'app-icon',
  imports: [],
  standalone: true,
  templateUrl: './icon.html',
  styleUrls: ['./icon.scss'],
})
export class IconComponent {
  @Input() name = '';
  @Input() height = '1.5rem';
  @Input() width = '1.5rem';
  @Input() viewBox = '0 0 24 24';
  @Input() color = 'var(--color-white)';
  @Input() ariaLabel?: string;

  get iconPath() {
    return IconMap[this.name] ?? '';
  }
}
